// The primary owns Global data and edge deployments' writable dependencies. Residency owns its
// Regional database, buckets and Redis; only Global operations continue reaching the primary.
//
// One definition, because "where is home" is asked by the database client, the S3 client factory, the Redis
// authority loader, and the Infisical environment name below. It was previously spelled as a bare
// 'us-west-1' literal in four places and as an unused PRIMARY_DATABASE_REGION in a fifth.
export const PRIMARY_REGION = 'us-west-1';

// Infisical holds one platform environment per region, named prod-<region>. The primary's environment is
// read explicitly by the loaders that must not fall back to the serving region's values.
export const PRIMARY_INFISICAL_ENVIRONMENT = `prod-${PRIMARY_REGION}`;
